import React from 'react';
import ReactDOM from 'react-dom';
import * as accommodationsData from './mockData/accommodations.json';
import '~/js/modules/stickyNav';
// import * as resortData from './mockData/accommodationsResort.json';
import dataLayerProvider from '~/js/modules/resorts/datalayer-provider';

import Accommodations from '~/js/components/resorts/accommodations/Accommodations';

const accomodations = document.getElementById('js-accommodations');
const resortData = beaches_app.page.resort;

const { dataLayer = {} } = window.beaches_app.page;

dataLayerProvider.inject(dataLayer);

ReactDOM.render(
  <Accommodations
    resortData={resortData}
    accommodationsData={accommodationsData}
  />,
  accomodations
);
